import $ from 'jquery';

export default function slider() {
    const $sliders = $('.wp-block-columns.slider');
    if (!$sliders.length) return;

    const debounce = (fn, ms = 150) => {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(null, args), ms);
        };
    };

    $sliders.each(function () {
        initSlider($(this));
    });

    $(window).on('resize.slider-init', debounce(() => {
        $sliders.each(function () {
            const $root = $(this);
            if ($root.data('sliderActive')) {
                const measure = $root.data('sliderMeasure');
                if (typeof measure === 'function') measure();
            }
        });
    }, 150));

    function initSlider($root) {
        if ($root.data('sliderActive')) return;

        const isTestimonials = $root.hasClass('testimonials');
        let $track = $root.children('.slider-track');

        if (!$track.length) {
            const $slides = $root.children('.wp-block-column');
            $slides.wrapAll('<div class="slider-track"></div>');
            $track = $root.children('.slider-track');
        }

        const $slides = $track.children('.wp-block-column');
        if (!$slides.length) return;

        $root.css({
            overflow: 'hidden',
            position: 'relative',
            touchAction: 'pan-y'
        });

        $track.css({
            display: 'flex',
            transition: 'transform 0.35s ease',
            willChange: 'transform'
        });

        $slides.css({
            flex: '0 0 100%',
            width: '100%',
            maxWidth: '100%'
        });

        let index = 0;
        let dragging = false;
        let startX = 0;
        let lastX = 0;
        let currentTX = 0;
        let movedPx = 0;
        let sliderW = 0;
        let slidesPerView = 1;
        let pageCount = 1;

        const $dots = $('<div class="slider-dots" role="tablist" aria-label="Slider pagination"></div>');
        $root.append($dots);

        function getSlidesPerView() {
            if (!isTestimonials) return 1;
            return window.innerWidth < 768 ? 1 : 3;
        }

        function getPageCount() {
            return Math.max(1, Math.ceil($slides.length / slidesPerView));
        }

        function getPageStartSlide(page) {
            return page * slidesPerView;
        }

        function getTrackGap() {
            const styles = window.getComputedStyle($track[0]);
            return parseFloat(styles.columnGap || styles.gap || '0') || 0;
        }

        function applySlideWidths() {
            slidesPerView = getSlidesPerView();

            if (!isTestimonials) {
                $slides.css({
                    flex: '0 0 100%',
                    width: '100%',
                    maxWidth: '100%'
                });
                return;
            }

            const gap = getTrackGap();
            const totalGap = gap * (slidesPerView - 1);
            const slideWidth = slidesPerView === 1
                ? '100%'
                : `calc((100% - ${totalGap}px) / ${slidesPerView})`;

            $slides.css({
                flex: `0 0 ${slideWidth}`,
                width: slideWidth,
                maxWidth: slideWidth
            });
        }

        function renderDots() {
            pageCount = getPageCount();
            index = Math.max(0, Math.min(index, pageCount - 1));

            $dots.empty();

            for (let i = 0; i < pageCount; i++) {
                const $dot = $(`<button type="button" class="slider-dot" data-i="${i}" aria-label="Go to slide ${i + 1}"></button>`);
                $dot.on('click.sliderDot', () => goTo(i));
                $dots.append($dot);
            }

            $dots.toggle(pageCount > 1);
        }

        function updateDots() {
            $dots.find('.slider-dot').removeClass('is-active').attr('aria-selected', 'false');
            $dots.find(`.slider-dot[data-i="${index}"]`).addClass('is-active').attr('aria-selected', 'true');
        }

        function setTranslate(px, animate = true) {
            $track.css('transition', animate ? 'transform 0.35s ease' : 'none');
            currentTX = px;
            $track.css('transform', `translate3d(${px}px,0,0)`);
        }

        function getSlideOffset(i) {
            const slide = $slides.get(i);
            return slide ? slide.offsetLeft : i * sliderW;
        }

        function getPageOffset(i) {
            return getSlideOffset(getPageStartSlide(i));
        }

        function goTo(i, animate = true) {
            index = Math.max(0, Math.min(i, pageCount - 1));
            setTranslate(-getPageOffset(index), animate);
            updateDots();
        }

        function measure() {
            sliderW = $root[0].clientWidth || $root[0].getBoundingClientRect().width;
            applySlideWidths();
            renderDots();
            goTo(index, false);
        }

        function onPointerDown(e) {
            if (pageCount <= 1) return;

            const ev = e.originalEvent || e;
            const $target = $(e.target);

            if (
                $target.closest('.icb-comparison-wrapper').length ||
                $target.closest('.icb-comparison-slider-handle').length ||
                $target.closest('a, button, input, textarea, select, label').length
            ) {
                return;
            }

            dragging = true;
            movedPx = 0;
            startX = lastX = ev.clientX;

            $track.css('transition', 'none');

            $root.on('pointermove.sliderDrag', onPointerMove);
            $(document).on('pointerup.sliderDrag pointercancel.sliderDrag', onPointerUp);
        }

        function onPointerMove(e) {
            if (!dragging) return;

            const ev = e.originalEvent || e;
            lastX = ev.clientX;

            const diff = lastX - startX;
            movedPx = Math.max(movedPx, Math.abs(diff));

            setTranslate(-getPageOffset(index) + diff, false);

            if (movedPx > 5) $root.addClass('is-dragging');
        }

        function onPointerUp() {
            if (!dragging) return;

            dragging = false;
            $root.removeClass('is-dragging');

            const diff = lastX - startX;
            const threshold = Math.max(40, sliderW * 0.12);

            if (Math.abs(diff) > threshold) {
                if (diff < 0) goTo(index + 1);
                else goTo(index - 1);
            } else {
                goTo(index);
            }

            $root.off('pointermove.sliderDrag');
            $(document).off('pointerup.sliderDrag pointercancel.sliderDrag');
        }

        $root.on('pointerdown.slider', onPointerDown);

        $root.on('keydown.slider', function (e) {
            if (pageCount <= 1) return;
            if (e.key === 'ArrowRight') goTo(index + 1);
            if (e.key === 'ArrowLeft') goTo(index - 1);
        });

        if (!$root.attr('tabindex')) $root.attr('tabindex', '0');

        let ro = null;
        if ('ResizeObserver' in window) {
            ro = new ResizeObserver(() => measure());
            ro.observe($root[0]);
        }

        measure();

        $root.data('sliderActive', true);
        $root.data('sliderMeasure', measure);
        $root.data('sliderRO', ro);
    }
}
